/**
 * List-table observer. Column drag-resize is disabled: leftover handles and
 * persisted widths are stripped, then overflow is marked so the action column
 * can stay sticky on wide tables.
 */
const SKIP = '.sip-pager, .modal, [data-sip-widget], .sip-dash-widget, .sip-home';

let observer = null;

function headerCells(table) {
    const row = table.querySelector('thead tr');
    return row ? Array.from(row.children) : [];
}

function shouldSkip(table) {
    if (!table) {
        return true;
    }
    if (table.closest(SKIP)) {
        return true;
    }
    if (!table.closest('.table-responsive, .nk-tb-list, .datatable-wrap')) {
        return true;
    }
    return headerCells(table).length < 2;
}

function markOverflow(table) {
    const wrap = table.closest('.table-responsive, .nk-tb-list, .datatable-wrap');
    if (!wrap) {
        return;
    }
    wrap.classList.toggle('is-overflowing', table.scrollWidth > wrap.clientWidth + 1);
}

function resetAppliedWidths(table) {
    table.classList.remove('sip-cols-resized');
    table.style.tableLayout = '';
    table.style.minWidth = '';
    table.querySelectorAll(':scope > colgroup > col').forEach(function (col) {
        col.style.width = '';
        col.style.minWidth = '';
        col.style.maxWidth = '';
    });
    headerCells(table).forEach(function (th) {
        th.classList.remove('sip-th-resize');
        th.style.width = '';
        th.style.minWidth = '';
        th.style.maxWidth = '';
    });
    delete table.dataset.sipColResize;
}

function stripColResize(table) {
    table.querySelectorAll('.sip-col-resizer').forEach(function (el) {
        if (el.parentNode) {
            el.parentNode.removeChild(el);
        }
    });
    if (table.classList.contains('sip-cols-resized') || table.dataset.sipColResize) {
        resetAppliedWidths(table);
    } else {
        headerCells(table).forEach(function (th) {
            th.classList.remove('sip-th-resize');
        });
    }
    markOverflow(table);
}

export function attachColResize(table) {
    if (shouldSkip(table)) {
        return;
    }
    stripColResize(table);
}

export function scanColResize(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.table-responsive > table.table, .table-responsive table.table').forEach(attachColResize);
}

export function observeListTables(root, extraScan) {
    const el = root || document.getElementById('root') || document.body;
    const run = function () {
        scanColResize(el);
        if (typeof extraScan === 'function') {
            extraScan(el);
        }
    };
    run();
    if (observer) {
        return;
    }
    observer = new MutationObserver(function () {
        if (observeListTables._tid) {
            clearTimeout(observeListTables._tid);
        }
        observeListTables._tid = setTimeout(run, 60);
    });
    observer.observe(el, { childList: true, subtree: true });
}

export default {
    bind: attachColResize,
    inserted: attachColResize,
    componentUpdated: attachColResize
};
